/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Minimum_Feature_1Inputs */

const et_plan_minimum_feature_1 = /** @type {(inputs: Plan_Minimum_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täielik konkurentsianalüüs`)
};

const en_plan_minimum_feature_1 = /** @type {(inputs: Plan_Minimum_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full competitor analysis`)
};

/**
* | output |
* | --- |
* | "Full competitor analysis" |
*
* @param {Plan_Minimum_Feature_1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_minimum_feature_1 = /** @type {((inputs?: Plan_Minimum_Feature_1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Minimum_Feature_1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_minimum_feature_1(inputs)
	return en_plan_minimum_feature_1(inputs)
});